export default __webpack_public_path__ + "static/media/image.w3-genesis.7904d8c9.png";